import { noop } from "lodash";
import React, { PropsWithChildren, createContext, useContext, useState } from "react";

//временный протез
const BuildingInvalidateKeyContext = createContext({ shouldUpdate: false, revalidate: noop });

export const BuildingInvalidateKeyContextProvider = ({ children }: PropsWithChildren) => {
  const [shouldUpdate, setShouldUpdate] = useState(false);

  const revalidate = () => {
    setShouldUpdate(true);
    setTimeout(() => {
      setShouldUpdate(false);
    }, 100);
  };

  return (
    <BuildingInvalidateKeyContext.Provider value={{ shouldUpdate, revalidate }}>
      {children}
    </BuildingInvalidateKeyContext.Provider>
  );
};

export const useBuildingInvalidateKeyContext = () => useContext(BuildingInvalidateKeyContext);
